<template>

<template-section v-if="!compact" :config="config" @deSelectSection="$emit('deSelectSection')" @selectSection="$emit('selectSection')" @removeSection="$emit('removeSection')">
	<!-- <template v-slot:default="componentScope"> -->
		<h2 class="section-title" v-if="config.drag">
			Custom Content
		</h2>
		<div class="height-control" v-if="sectionSelected">
			<h4>Height</h4>
			<input type="range" min="120" max="700" step="10" v-model="sectionHeight">
		</div>
		<div :class="[ 'custom-content-section' ]" :data-section_hash="hash" :style="sectionStyle" v-if="!config.drag" id="content_preview">
			<div :class="[ 'text-section', textDivWidthClass, textDivAlignmentClass ]" :style="textDivStyle" v-html="options.content"></div>
		</div>

	<!-- </template> -->

	<template v-slot:sectionEdit>
		<div class="column">
			<h3>Backround Image</h3>
			<div class="image-thumb" v-if="backgroundImage.image_src">
				<img class="background-image-thumb" :src="backgroundImage.image_src">
				<div class="remove-link pointer" @click="backgroundImage = { image_src: null, image_id: null }">Remove</div>
			</div>
			<vue-dropzone @vdropzone-success="backgroundUploadSuccess" :ref="'customContentDropzone_' + config.index" :id="'custom_content_dropzone_' + config.index" :options="backgroundImgDropzoneOptions" v-else></vue-dropzone>
		</div>
		<div class="column span-two last">
			<h3>Text Block</h3>
			<div class="form-quarter control-group">
				<label class="dark-font radio first">
					<input type="radio" v-model="textDivShow" :value="1">
					<span class="show"><i class="fas fa-check-circle"></i>Show</span>
				</label>
				<label class="dark-font radio last">
					<input type="radio" v-model="textDivShow" :value="0">
					<span class="hide"><i class="fas fa-check-circle"></i>Hide</span>
				</label>
			</div>
			<h4>Width</h4>
			<select v-model="textDivWidthClass">
				<option value="one-half">One-half</option>
				<option value="two-thirds">Two-thirds</option>
				<option value="three-fourths">Three-fourths</option>
				<option value="full">Full</option>
			</select>
			<h4>Alignment</h4>
			<select v-model="textDivAlignmentClass">
				<option value="left">Left</option>
				<option value="center">Center</option>
				<option value="right">Right</option>
			</select>
			<h4>Background Color</h4>
			<color-picker :disable="!textDivShow" :selected="textDivBackgroundColor" :colors="getColorSchemeColors" :rgb="true" @colorClick="updateValue('textDivBackgroundColor', $event)"></color-picker>
			<h4>Transparency</h4>
			<div class="range-group">
				<label>More</label>
				<input :disabled="!textDivShow" type="range" min="1" max="10" v-model="textDivOpacity">
				<label>Less</label>
			</div>
			<h4>Text Color</h4>
			<color-picker :disable="!textDivShow" :selected="color" :colors="getColorSchemeFontColors" @colorClick="updateValue('color', $event)"></color-picker>
		</div>
		<div class="column span-three">
			<h3>Content</h3>
			<ckeditor :editor="editor" v-model="content" :config="editorConfig" @ready="editorReady"></ckeditor>

		</div>
	</template>
</template-section>

<div v-else>Custom Content <i class="fas fa-grip-horizontal"></i></div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import Link from '@ckeditor/ckeditor5-link/src/link';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import List from '@ckeditor/ckeditor5-list/src/list';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import { Undo, Redo } from '@ckeditor/ckeditor5-undo/src/';

import CDSUploadAdapter from '@/modules/website/components/contentpagesuploadadapter.js';

import ColorPicker from '../components/ColorPicker.vue'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
	name: 'custom-content',
	props: [ 'selectedSection', 'compact', 'config', 'options'],
    components: {
        'color-picker': ColorPicker,
        'vue-dropzone': vue2Dropzone,
        'ckeditor': CKEditor.component
    },
	data() {
		return {
			editor: ClassicEditor,
			sectionSelected: null,
			editorConfig: {
                plugins: [
					Alignment,
					Image,
					ImageToolbar,
					ImageCaption,
					ImageStyle,
					ImageResize,
					ImageUpload,
                    Bold,
                    Italic,
					Underline,
                    Link,
                    Paragraph,
					Heading,
					List,
					MediaEmbed,
					Undo
                ],
                toolbar: {
                    items: [
                        'bold',
                        'italic',
						'underline',
						'heading',
						'link',
						'alignment:left',
						'alignment:center',
						'alignment:right',
						'numberedList',
						'bulletedList',
						'imageUpload',
						'mediaEmbed',
                        'undo',
                        'redo',
                    ]
                },
				extraPlugins: [ this.theUploadAdapterPlugin ],
				heading: {
		            options: [
		                { model: 'paragraph', title: 'Paragraph' },
		                { model: 'heading1', view: 'h1', title: 'Heading 1' },
						{ model: 'heading2', view: 'h2', title: 'Heading 2' },
		                { model: 'heading3', view: 'h3', title: 'Heading 3' },
						{ model: 'heading5', view: 'h5', title: 'Button' },
						{ model: 'heading6', view: 'h6', title: 'Button Light' },
					]
				},
				mediaEmbed: {
					removeProviders: [ 'dailymotion', 'spotify', 'instagram', 'twitter', 'googleMaps', 'flickr', 'facebook' ] // 'vimeo', 
				}
            },
			content: '',
			localOptions: {
				backgroundImage: {
					image_src: 'https://s3.us-east-2.amazonaws.com/dev-shootingsportsmedia/templates/843814.jpg',
					image_id: null
				},
				sectionHeight: 360,
				textDivShow: 1,
				// textDivOpacity: 5,
				textDivBackgroundColor: '#ffffff',
				textDivMarginLeft: 33,
				textDivMarginRight: 0,
				color: '#000000',
				content: null,
				fontFamily: 'Helevetica, Arial, sans-serif'
			},
			originalHeight: 300,
			offsetY: 0,
			styleOptions: {
				backgroundColor: [
					{ value: '28, 58, 82' },
					{ value: '0, 0, 0' },
					{ value: '255, 255, 255', light: true }
				],
				color: [
					{ value: '#1c3a52' },
					{ value: '#000000' },
					{ value: '#ffffff', light: true }
				],
				fontFamily: {
					'Helevetica': 'Helevetica, Arial, sans-serif',
					'Georgia': 'Georgia, serif',
					'Cursive': 'cursive',
					'Fantasy': 'fantasy',
				}
			}
		}
	},
	created() {
		if (!this.compact && !this.config.hash) {
			this.hash = [...Array(32)].map(i=>(~~(Math.random()*36)).toString(36)).join('')
			this.updateStyle()
		}
	},
	mounted() {
		this.localOptions = this.options

		if (this.options) {
			this.originalHeight = this.options.sectionHeight
			this.textDivShow = this.options.textDivShow
		}
			this.convertOembedToIFrame()
	},
	watch: {
		options(newVal) {
			this.localOptions = this.options
		},
		content(newVal) {
			this.updateTemplateData({ path: 'pageSections[' + this.localIndex + '].options.content', value: newVal })
			this.convertOembedToIFrame()
		},
		config(newVal, oldVal) {
			// console.log(newVal, oldVal)
			this.sectionSelected = newVal.selectedSection == newVal.index
			// if (!this.compact && !this.hash) {
			// 	// this.updateTemplateData({ path: 'pageSections[' + this.localIndex + '].hash', value: [...Array(32)].map(i=>(~~(Math.random()*36)).toString(36)).join('') })
			// 	this.hash = [...Array(32)].map(i=>(~~(Math.random()*36)).toString(36)).join('')
			// 	console.log(this.getTemplateData.pageSections[this.localIndex].hash)
			// 	this.updateStyle()
			// }
		},
		localOptions: {
			handler: function(newVal) {
				// console.log(newVal)
			},
			deep: true
		},
		offsetY(value) {
			// console.log(this.originalHeight + value, value)
		},
		originalHeight(value) {
			// console.log(value)
		},
		'getTemplateData.siteOptions.colorScheme'(newVal, oldVal) {
			if (newVal != oldVal) {
				this.updateStyle()
			}
		}
	},
	computed: {
        ...mapGetters('website_module', [
            'getTemplateData',
            'getColorSchemeColors',
            'getColorSchemeFontColors',
        ]),
		localIndex() {
			if (!this.config) return
			return this.config.index - 1
		},
		hash: {
			get() {
				return this.getTemplateData.pageSections[this.localIndex].hash
			},
			set(value) {
				this.updateTemplateData({ path: 'pageSections[' + this.localIndex + '].hash', value: value })
			}
		},
		backgroundImgDropzoneOptions() {
			return {
				url: this.getImageUploadAPI,
				withCredentials: true,
				uploadMultiple: false,
				paramName: 'upload_file',
				maxFilesize: 1.0,
				addRemoveLinks: true,
				params: {
					fd_token: this.$getCookie('dashboard_token'),
					source: 'WEBSITE',
					context: 'MARQUEE',
					variation: 'large',
					image_id: this.localOptions.backgroundImage.image_id || '',
					template_data_id: this.getTemplateData.template_data_id || ''
				}
			}
		},
		sectionStyle() {
			var imageSrc = (this.backgroundImage.image_src) ? "url(" + this.backgroundImage.image_src + ")" : null
			return {
				backgroundImage: imageSrc,
				minHeight: this.sectionHeight + "px"
			}
		},
		textDivStyle() {
			return {
				minHeight: this.sectionHeight + "px",
				display: (this.textDivShow) ? 'block' : 'none',
				backgroundColor: "rgba(" + this.textDivBackgroundColor + "," + (this.textDivOpacity / 10) + ")"
			}
		},
		sectionHeight: {
			get() {
				return this.getTemplateData.pageSections[this.localIndex].options.sectionHeight
			},
			set(value) {
				this.updateTemplateData({ path: 'pageSections[' + this.localIndex + '].options.sectionHeight', value: value })
				this.updateStyle()
			}
		},
		textDivShow: {
			get() {
				return this.getTemplateData.pageSections[this.localIndex].options.textDivShow
			},
			set(value) {
				// console.log(value)
				this.updateTemplateData({ path: 'pageSections[' + this.localIndex + '].options.textDivShow', value: value })
			}
		},
		textDivWidthClass: {
			get() {
				return this.getTemplateData.pageSections[this.localIndex].options.textDivWidthClass
			},
			set(value) {
				console.log(value)
				this.updateTemplateData({ path: 'pageSections[' + this.localIndex + '].options.textDivWidthClass', value: value })
			}
		},
		textDivAlignmentClass: {
			get() {
				return this.getTemplateData.pageSections[this.localIndex].options.textDivAlignmentClass
			},
			set(value) {
				console.log(value)
				this.updateTemplateData({ path: 'pageSections[' + this.localIndex + '].options.textDivAlignmentClass', value: value })
			}
		},
		textDivOpacity: {
			get() {
				return this.getTemplateData.pageSections[this.localIndex].options.textDivOpacity
			},
			set(value) {
				// console.log(value)
				this.updateTemplateData({ path: 'pageSections[' + this.localIndex + '].options.textDivOpacity', value: value })
				this.updateStyle()
			}
		},
		backgroundImage: {
			get() {
				return this.getTemplateData.pageSections[this.localIndex].options.backgroundImage
			},
			set(value) {
				// console.log(value)
				this.updateTemplateData({ path: 'pageSections[' + this.localIndex + '].options.backgroundImage', value: value })
				this.updateStyle()
			}
		},
		textDivBackgroundColor: {
			get() {
				return (this.getTemplateData.pageSections[this.localIndex].options.textDivBackgroundColor.value !== '')
					? this.getTemplateData.pageSections[this.localIndex].options.textDivBackgroundColor.value
					: this.getTemplateData.pageSections[this.localIndex].options.textDivBackgroundColor.defaultColor
			}
		},
		color: {
			get() {
				return (this.getTemplateData.pageSections[this.localIndex].options.color.value !== '') ? this.getTemplateData.pageSections[this.localIndex].options.color.value : this.getTemplateData.pageSections[this.localIndex].options.color.defaultColor
			}
		}
	},
	methods: {
        ...mapActions('website_module', [
            'updateTemplateDescription',
            'updateTemplateData',
            'updateTemplateDataId',
            'copyTemplateData'
        ]),
		editorReady() {
			this.content = this.options.content
		},
		updateStyle() {
			console.log(this.localOptions, this.getTemplateData.pageSections[this.localIndex].hash)
			if (!this.localOptions || !this.getTemplateData.pageSections[this.localIndex].hash) return

			var imageSrc = this.backgroundImage.image_src,
			styles = {}
			styles[".custom-content-section[data-section_hash='" + this.getTemplateData.pageSections[this.localIndex].hash + "']"] = {
				'background-image': (imageSrc) ? "url(" + imageSrc + ")" : "",
				'min-height': this.localOptions.sectionHeight + "px"
			}
			var textDivBackgroundColor = this.getColorSchemeColors[this.textDivBackgroundColor]
			styles['.custom-content-section[data-section_hash="' + this.getTemplateData.pageSections[this.localIndex].hash + '"] .text-section'] = {
				"display": (this.textDivShow) ? 'inline-block' : 'none',
				"background-color": "rgba(" + textDivBackgroundColor + "," + (this.textDivOpacity / 10) + ")"
			}
			styles[".custom-content-section[data-section_hash='" + this.getTemplateData.pageSections[this.localIndex].hash + "'] .text-section *"] = {
				"color": "rgb(" + this.getColorSchemeFontColors[this.color] + ")",
			}
			console.log(this.color, this.getColorSchemeFontColors[this.color])
			console.log(styles[".custom-content-section[data-section_hash='" + this.getTemplateData.pageSections[this.localIndex].hash + "'] .text-section *"])
			this.updateTemplateData({ path: 'pageSections[' + this.localIndex + '].options.styles', value: styles })
		},
		updateValue(prop, value) {
			console.log(prop, value)
			this.updateTemplateData({ path: 'pageSections[' + this.localIndex + '].options["' + prop + '"].value', value: value })
			this.updateStyle()
		},
		updateDivHeight(value) {
			this.offsetY = value
			// console.log(this.localOptions.sectionHeight)
			var height = this.originalHeight + value
			this.localOptions.sectionHeight = height
			this.updateTemplateData({ path: 'pageSections[' + this.localIndex + '].options.sectionHeight', value: height })
			// this.updateStyle()
		},
		theUploadAdapterPlugin(editor) {
			editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
				return new CDSUploadAdapter(loader);
			}
		},
		backgroundUploadSuccess(file, response) {
			var response = JSON.parse(response)
            // TODO: is this redundant with store.js?
			// if (response.status == 'login_required') {
			// 	this.$store.commit('UPDATE_LOGIN_REQUIRED', true)
	        // 	var location = '/login?return=' + encodeURI(document.location.pathname + document.location.search)
        	// 	document.location.replace(location)
			// }
			this.updateTemplateData({ path: 'pageSections[' + this.localIndex + '].options.backgroundImage', value: response.image })
			// this.updateStyle()
			this.$refs['customContentDropzone_' + this.config.index].removeAllFiles()
		},
		theUploadAdapterPlugin(editor) {
			editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
				return new CDSUploadAdapter(loader);
			}
		},
		convertOembedToIFrame() {
			//setTimeout(() => {
				let media = document.querySelectorAll('figure.media oembed')
				media.forEach(async element => {
					let url = element.getAttribute('url')
					await fetch(`https://www.youtube.com/oembed?url=${url}`).then(response => {
						return response.json()
					}).then(obj => {
						let iframe = new DOMParser().parseFromString(obj.html, "text/html").body.firstElementChild
						let ratio = obj.width / obj.height
						iframe.width = 900
						iframe.height = 900 / ratio
						element.parentNode.replaceChild(iframe, element)
					})
				});
			//}, 1000)
		}

	}
}
</script>

<style lang="scss">

h5 {
	font-size: 1em;
	a {
		background-color: #000;
		padding: 0.75em 1.25em;
		color: #fff !important;
	}
	a:hover {
		background-color: #1f1f1f;
	}
	.ck-link_selected { background: #000000a6 !important; }
}

h6 {
	font-size: 1em;
	a {
		background-color: #fff;
		padding: 0.75em 1.25em;
		color: #000 !important;
	}
	a:hover {
		background-color: #e8e8e8;
	}
}

figure.media {
	margin: 0;
}
</style>
